import { ChevronRight } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowButtonRight1 = mkIcon(ChevronRight);